<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <TuiEditor
                ref="tuiEditor"
                v-model="selectedComment.Note"
              ></TuiEditor>
              <!-- <v-textarea
                label="Note"
                v-model="selectedComment.Note"
                :rules="[(v) => !!v || 'required']"
              ></v-textarea> -->
            </v-col>
          </v-row>
          <v-row v-if="true">
            <v-col sm="12">
              <v-checkbox
                label="Is Private"
                v-model="selectedComment.IsPrivate"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="!selectedComment.ID">
            <v-col sm="12">
              <User
                label="Notify Users"
                v-model="selectedComment.Notifications"
                selfKey="CommentID"
                :items="availableUsers"
                :billID="selectedTrackedBill.ID"
                :selfID="selectedComment.ID"
                relatedItemKey="UserID"
                joinItemName="Notification"
              >
                <template v-slot:item="{ item, index }">
                  <span v-if="item.FirstName && item.LastName">
                    {{ item.FirstName }} {{ item.LastName }}
                  </span>
                  <span v-else>{{ item.Email }}</span>
                  <span class="ml-2">
                    <v-chip
                      small
                      label
                      :color="item.directOverride ? 'accent' : ' primary'"
                      v-if="item.agency"
                      >{{ item.agency.Abr }}
                    </v-chip>
                  </span>
                  <span
                    class="ml-2"
                    v-if="item.AgencyPerm != item.TrackedBillPermissionID"
                  >
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 3"
                      label
                      color="secondary"
                      small
                      position="right"
                      icon="mdi-eye"
                      >Viewer</BaseTooltipChip
                    >
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 2"
                      label
                      color="secondary"
                      small
                      position="right"
                      icon="mdi-pencil"
                      >Editor</BaseTooltipChip
                    >
                    <BaseTooltipChip
                      v-if="item.TrackedBillPermissionID == 1"
                      label
                      position="right"
                      color="secondary"
                      small
                      icon="mdi-check-decagram"
                      >Owner</BaseTooltipChip
                    ></span
                  >
                </template>
              </User>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col sm="12">
              <v-text-field
                label="Tracked Bill ID"
                v-model="selectedComment.TrackedBillID"
                type="number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Created By ID"
                v-model="selectedComment.CreatedByID"
                type="number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <BaseDatePickerWithText
                label="Created Date mm/dd/yyyy"
                v-model="selectedComment.CreatedDate"
                :rules="[(v) => !!v || 'required']"
              ></BaseDatePickerWithText>
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Deleted"
                v-model="selectedComment.IsDeleted"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveCommentDetails" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import Comment from '@classes/Comment'
import TuiEditor from '@components/TuiEditor'
import { authComputed } from '@state/helpers'
import User from '@components/select/a-multi-join/User'

//templateTODO: import lookup components you plan to use
export default {
  components: { TuiEditor, User },
  data: () => ({
    dialog: false,
    valid: true,
    selectedComment: new Comment(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...authComputed,
    ...get('comment', ['saving']),
    ...get('trackedBill', ['selectedTrackedBill', 'selectedTrackedBillUsers']),
    billID() {
      if (this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
    },
    availableUsers() {
      var privateCommentPermissions = [1, 5, 2]
      if (!this.selectedComment.IsPrivate) {
        return this.selectedTrackedBillUsers
      } else {
        return this.selectedTrackedBillUsers
          .slice()
          .filter((x) =>
            privateCommentPermissions.includes(x.TrackedBillPermissionID)
          )
      }
    },
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('comment', ['saveComment']),
    async validate() {
      this.$refs.form.validate()
    },
    editComment(entry) {
      this.selectedComment = new Comment(entry)
      this.modalText = 'Edit Comment'
      this.dialog = !this.dialog
    },
    addComment() {
      this.modalText = 'Insert Comment'
      this.selectedComment = new Comment({ TrackedBillID: this.billID })
      this.dialog = !this.dialog
    },
    saveCommentDetails() {
      this.$refs.tuiEditor.getMarkdown()
      this.validate().then(() => {
        if (this.valid) {
          // var text = this.$refs.toastuiEditor.invoke('getMarkdown')
          // this.selectedComment.Note = text
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveComment(this.selectedComment.removeRelated()).then(
            (res) => {
              this.$emit('refresh')
              this.selectedComment = new Comment()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedComment = new Comment()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
